import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SharedService } from '../../services/shared.service';
import { AclService } from '../../services/acl.service';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.css']
})
export class NavComponent implements OnInit {

  isUserLoggedIn: boolean = false;
  LoggedUserName: String;
  pages  = 0;
  userNumber: any = 0;
  accesslevelNumber: any = 0;
  constructor( private router: Router,private sharedService: SharedService, private aclService: AclService) {
    this.sharedService.IsUserLoggedIn.subscribe( value => {
		
	    console.log('nav');
        this.isUserLoggedIn = value;
        console.log(this.isUserLoggedIn);
        if(this.isUserLoggedIn)
		      this.getUserAccessNav();
    });
	this.sharedService.LoggedUserName.subscribe( value => {
		console.log(value);
		//console.log('here');
        this.LoggedUserName = value;
    });
  }

  ngOnInit() {
	  
  }
  getUserAccessNav() {   
   this.aclService.getRoles().then(userRoles => { 
		for(let pages of Object.values(userRoles)) {  
			if(pages.page == 'user') {	
					var accFunc = pages.functionality;		
					if(accFunc.includes('view') == true) { 
					this.userNumber = 0; 
					} else { this.userNumber = 1;
					}								
			}
			if(pages.page == 'accesslevel') {	
					var accFunc = pages.functionality;		
					if(accFunc.includes('view') == true) { 
					this.accesslevelNumber = 0; 
					} else { this.accesslevelNumber = 1;
					}								
			}
		}
		 
	});
  }
	
  goHome() {
	this.router.navigate(['dashboard']);
  }
  
  goUsers() {
	this.router.navigate(['users']);
  }
  
  goProject() {
	this.router.navigate(['project']);
  }
  
  goApplication() {
	this.router.navigate(['application']);
  }
  
  getRoles() {
	this.router.navigate(['role']);
  }
  
  goAccesslevel() {
	this.router.navigate(['accesslevel']);
  }
  
}
